var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"d-flex justify-center mt-0"},[_vm._v(" Ups... ¿Cómo llegó usted aquí? ¯\\_(ツ)_/¯ ")])
}
var staticRenderFns = []

export { render, staticRenderFns }